/**
 * Offline component script class
 *
 * @package    Common
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';

export default class OfflinePage extends PureComponent {
    refreshPage = () => {
        window.location.reload();
    };

    render () {
        return (
            <div className="registration-site-content">
                <div className="registration-site-content-offline">
                    <i className="fas fa-5x fa-wifi m-b-30"/>

                    <FormattedMessage id="labels.offline"/>

                    <button type="button" className="btn btn-primary m-t-30" onClick={ this.refreshPage }>
                        <i className="fas fa-redo-alt m-r-5"/>
                        <FormattedMessage id="buttons.refresh"/>
                    </button>
                </div>
            </div>
        );
    }
}
